export default "__VITE_ASSET__D_6B$G1R__"